import { ArrowIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, gallery } from "../site";

export function GalleryPage() {
  return (
    <>
      <PageHero
        eyebrow="Our work"
        title="Color, texture, detail."
        description="A glimpse of the curls, braids, updos, dimensional finishes, and special-event looks created in the Nadia’s Salon chairs."
        image="/images/gallery/legacy-gallery-01.jpg"
        compact
      />
      <section className="section gallery-section">
        <div className="container">
          <div className="gallery-grid">
            {gallery.map((image, index) => (
              <figure key={image.src} className="gallery-item">
                <img src={image.src} alt={image.alt} loading={index > 7 ? "lazy" : "eager"} decoding="async" />
              </figure>
            ))}
          </div>
          <div className="gallery-booking">
            <p>Have a reference photo or a look in mind? Bring it to a free consultation and we’ll talk through what it takes to make it work for you.</p>
            <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">Book an appointment <ArrowIcon /></a>
          </div>
        </div>
      </section>
    </>
  );
}
